import authHeaders from "./authHeaders";
import fetchUrl from "./fetchUrl";

function searchNewSelect(field) {
  return (searchTerm) =>
    fetch(
      fetchUrl(
        `/v1/new_select/${field}`,
        {
          term: searchTerm,
        },
        process.env.REACT_APP_VTS_API
      ),
      { headers: authHeaders() }
    ).then((r) => {
      if (!r.ok) {
        throw r;
      } else {
        return r.json();
      }
    });
}

export default searchNewSelect;
